export default "__VITE_ASSET__qHMBNgSa__"